import { getTipByPath } from '@/lib/getTip';
export default function homeCollectionLoader() {
    const tip = getTipByPath('/:postcode/home/collection');
    return { tip };
}
